import { Button } from '@/components/ui/button.js';
import { RefreshSessionZoomLink } from '@/components/session/refresh-session-zoom-link.js';
import { AdminSession } from '@airreading/common/data';

interface RefreshZoomLinkButtonProps {
  session: AdminSession;
  trigger?: React.ReactNode;
}

export const RefreshZoomLinkButton = ({ session, trigger }: RefreshZoomLinkButtonProps) => {
  return (
    <RefreshSessionZoomLink
      session={session}
      trigger={
        trigger || (
          <Button variant="outline" className="bg-slate-100 hover:bg-slate-200">
            Refresh Zoom host link
          </Button>
        )
      }
    />
  );
};
